<!--
 * @Author: DouDou
 * @LastEditors: DouDou
 * @Date: 2020-09-21 16:24:50
 * @LastEditTime: 2020-09-28 20:29:54
 * @Description: File description
-->
<template>
  <div class="loginHandle">
    <!-- 登录注册弹框 -->
    <van-popup v-model="isShowLogin" class="x-van-popup">
      <xes-tal-login
        :loginData="loginOptions"
        @loginSuccess="loginSuccess"
        @regSuccess="regSuccess"
        @sendVCode="sendVCode"
        @close="isShowLogin = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { XesTalLogin } from '@xes/terra'

export default {
  name: 'LoginHandle',
  components: { XesTalLogin },
  data () {
    return {
      isShowLogin: false,
      // 登录所需参数
      loginOptions: {
        sGroupId: '20001',
        source_id: window._wltfChannel.hotUrlParams.source || window._wltfChannel.urlParmas.source_id || ''
      }
    }
  },
  // computed: {}
  // watch: {},
  // created () {},
  // mounted () {},
  methods: {
    // 点击获取验证码按钮
    sendVCode (params) {
      console.log(params)
    },
    // 新用户注册成功
    regSuccess () {
      this.$xesLogger.clickMsg({
        params: { clickid: '5.3.13', action: 'regSucess', status: '2' }
      })
      window.location.reload()
    },
    // 老用户登录成功
    loginSuccess () {
      this.$xesLogger.clickMsg({
        params: { clickid: '5.3.13', action: 'loginSucess', status: '1' }
      })
      window.location.reload()
    },
    // 调用登录：原生或h5. 非跳转登录(login)页面/路由
    callLogin () {
      this.$xesLogger.clickMsg({
        params: { clickid: '5.3.13', action: 'callLogin', status: '0' }
      })
      const _ua = navigator.userAgent.toLowerCase()
      // app 调用原生登录
      if (/jzh$/.test(_ua) && xesApp) {
        // 登录后的回调
        window.goApplogin = function (params) {
          if (params === 1) {
            const isAndroid =
              navigator.userAgent.indexOf('Android') > -1 ||
              navigator.userAgent.indexOf('Adr') > -1
            if (isAndroid) window.location.reload()
          }
        }
        xesApp.xesLogin('goApplogin')
      } else {
        // h5 展示 登录弹窗
        this.isShowLogin = true
      }
    }
  }
}
</script>
